"use client";
import {
  useSelectList
} from "../__chunks/RTMHTBK3.js";
import "../__chunks/QRAMDWD7.js";
import {
  useSelectProviderContext
} from "../__chunks/SYZHUNAU.js";
import "../__chunks/CDZXDIC7.js";
import "../__chunks/3IEDWLST.js";
import "../__chunks/QFI3MCMR.js";
import "../__chunks/6LTHW2TQ.js";
import {
  usePopover
} from "../__chunks/6YVAEELE.js";
import {
  createDialogComponent
} from "../__chunks/FGHVVLPU.js";
import "../__chunks/CMFBAHKI.js";
import "../__chunks/HSFE2URL.js";
import "../__chunks/H2NVVTJB.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/YNKDLCEK.js";
import "../__chunks/3TEK3C5Q.js";
import "../__chunks/4ZRXV5C7.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/MKDDWKFK.js";
import "../__chunks/5QL6BP6J.js";
import "../__chunks/OOBDFMJL.js";
import "../__chunks/BC72XE6E.js";
import "../__chunks/53CQGCDZ.js";
import "../__chunks/4KKLZMKS.js";
import "../__chunks/UHSH3H5I.js";
import "../__chunks/UYRJLDVS.js";
import "../__chunks/XPF5GU3Q.js";
import "../__chunks/JPQNKTGF.js";
import "../__chunks/LQTCWTYB.js";
import "../__chunks/7452U3HH.js";
import "../__chunks/KCMTTTFR.js";
import "../__chunks/4MFOHMLS.js";
import "../__chunks/5B3U64HV.js";
import "../__chunks/IWHI6Y45.js";
import "../__chunks/RG6J4TID.js";
import "../__chunks/7JCFLN3D.js";
import "../__chunks/SHA3WOPI.js";
import "../__chunks/JG4BJLXB.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/GUCZNEAD.js";
import "../__chunks/2KACNUKS.js";
import "../__chunks/ZIX5D53S.js";
import "../__chunks/PWUXK5IM.js";
import "../__chunks/WOWUAP42.js";
import "../__chunks/XM66DUTO.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/select/select-popover.ts
var TagName = "div";
var useSelectPopover = createHook(
  function useSelectPopover2(_a) {
    var _b = _a, { store, alwaysVisible } = _b, props = __objRest(_b, ["store", "alwaysVisible"]);
    const context = useSelectProviderContext();
    store = store || context;
    props = useSelectList(__spreadValues({ store, alwaysVisible }, props));
    props = usePopover(__spreadValues({ store, alwaysVisible }, props));
    return props;
  }
);
var SelectPopover = createDialogComponent(
  forwardRef(function SelectPopover2(props) {
    const htmlProps = useSelectPopover(props);
    return createElement(TagName, htmlProps);
  }),
  useSelectProviderContext
);
export {
  SelectPopover,
  useSelectPopover
};
